import './biebelscatering2/style';
import FormStructure from './biebelscatering2/form_structure';

export default FormStructure;